import React from 'react'

import { LntModal } from '@app/components/base'

import { RemoveListModalProps } from './types'

export const RemoveListModal: React.FC<RemoveListModalProps> = props => {
  const { onRemoveList, title, ...restProps } = props

  return (
    <LntModal
      { ...restProps }
      title={ title }
      onOk={ onRemoveList }
      okText='Да'
      cancelText='Нет'
    />
  )
}
